<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/']"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">

            <span> وضعیت تخلیه فیلم ها  </span>

        </a>

    </div>

</div>

<main class="py-4 px-2">

    <form class="row gx-2 gy-md-0 gy-3" [formGroup]="mdl_Request">

         <!-- پارکینگ -->
        
        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> پارکینگ </label>

            <select class="form-select p-2" formControlName="iVS_Parking">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Parking" [value]="item.iVS_Parking">

                    {{item.strName}}

                </option>

            </select>

        </div>

        <!-- خودرو -->
        
        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> خودرو </label>

            <select class="form-select p-2" formControlName="strUnitID">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Car" [value]="item.strUnitID">

                    {{item.strFullName}}

                </option>

            </select>

        </div>

         <!-- از تاریخ -->

        <div class=" col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> از تاریخ </label>
                
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                
                <input formControlName="strSDate" class="form-control p-2 text-end" />
                
            </ng-persian-datepicker>
                
        </div>

        <!-- تا تاریخ -->

        <div class=" col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> تا تاریخ </label>
                
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                
                <input formControlName="strEDate" class="form-control p-2 text-end" />
                
            </ng-persian-datepicker>
                
        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-primary w-100 p-2" (click)="getReport()"> 

                &nbsp; جستجو &nbsp;
                
            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-success w-100 p-2" (click)="Exportexcel('Export_Excel')"> 

                &nbsp; خروجی اکسل &nbsp;
                
            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <!-- فیلتر جستجو -->

        <div class="row gx-2 gy-md-0 gy-3">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 220px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="">
        
                        <th class="text-center"> # </th>
    
                        <th class="text-center"> شهر </th>
                        
                        <th class="text-center"> پارکینگ </th>

                        <th class="text-center"> خودرو </th>

                        <th class="text-center"> کد </th>

                        <th class="text-center"> زمان شناسایی </th>

                        <th class="text-center"> حافظه اشغال شده (MB) </th>

                        <th class="text-center"> آخرین زمان تخلیه  </th>

                        <th class="text-center"> حجم تخلیه شده (MB)</th>

                        <th class="text-center"> حجم باقیمانده (MB)</th>

                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td>{{ item.strCityName | faNum }}</td>
                        
                        <td>{{ item.strName | faNum }}</td>

                        <td>{{ item.strFullName | faNum }}</td>

                        <td>{{ item.iCode | faNum }}</td>

                        <td>{{ item.strDateTime | faNum}}</td>

                        <td>{{ item.UsedSpaceMB.toLocaleString()  | faNum }} </td>

                        <td>{{ item.strLastUpdate | faNum }}</td>

                        <td>{{ item.DownloadedMB.toLocaleString()  | faNum }} </td>

                        <td>{{ item.RemainderMB.toLocaleString() | faNum }} </td>

                    </tr>

                    <tr *ngIf="lst_Report.length > 0" class="col-12 text-center" style="background-color: #c7d2fe;">

                        <td> سرجمع : {{ lst_Report.length.toLocaleString() | faNum }} </td>

                        <td></td>

                        <td></td>

                        <td></td>

                        <td></td>

                        <td></td>

                        <td> {{ obj_Report.UsedSpaceMB.toLocaleString() | faNum }} </td>

                        <td></td>

                        <td> {{ obj_Report.DownloadedMB.toLocaleString() | faNum }} </td>

                        <td> {{ obj_Report.RemainderMB.toLocaleString() | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>


</main>